import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/api";

const CurrencyCtx = createContext(null);

const SYMBOL = { EUR: "€", USD: "$", TRY: "₺" };

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyRaw] = useState(() => localStorage.getItem("wabtec_currency") || "EUR");
  const [fx, setFx] = useState({ EUR: 1, USD: 1.08, TRY: 35 });

  useEffect(() => {
    refreshFx();
  }, []);

  async function refreshFx() {
    try {
      const { data } = await api.get("/settings");
      setFx({ EUR: 1, USD: Number(data.fx_eur_usd) || 1.08, TRY: Number(data.fx_eur_try) || 35 });
    } catch {
      // ignore
    }
  }

  const setCurrency = (c) => {
    setCurrencyRaw(c);
    localStorage.setItem("wabtec_currency", c);
  };

  /** Convert an EUR amount to the active currency and format it. */
  const fmt = (eurValue, opts = {}) => {
    if (eurValue == null || isNaN(eurValue)) return "—";
    const rate = fx[currency] ?? 1;
    const v = Number(eurValue) * rate;
    const sym = SYMBOL[currency] || "";
    const abs = Math.abs(v);
    const compact = opts.compact !== false;
    if (compact && abs >= 1_000_000) return `${(v / 1_000_000).toFixed(2)} M${sym}`;
    if (compact && abs >= 1_000) return `${(v / 1_000).toFixed(1)} k${sym}`;
    return `${v.toFixed(opts.decimals ?? 0)} ${sym}`.trim();
  };

  return (
    <CurrencyCtx.Provider value={{ currency, setCurrency, fx, fmt, refreshFx, symbol: SYMBOL[currency] }}>
      {children}
    </CurrencyCtx.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyCtx);
